import { useEffect, useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getPackagesCommission,
  getReservationsByProductType,
  getTotalGrossIncludePackagedItem,
  price,
} from 'utils/helpers';
import { useCurrentBookingState } from 'utils/hooks/use_current_booking_state';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import Experiences from './experiences';

const ExperiencesCard = ({ onlyShowInfo = false }) => {
  const { isFullyPaid } = useCurrentBookingState();
  const [experiencesOpen, setExperiencesOpen] = useState(true);
  const booking = useSelector(getCurrentBooking);
  const experienceReservations = getReservationsByProductType(
    'experience',
    booking
  );

  // Auto expand section on receipt page
  useEffect(() => {
    setExperiencesOpen(experiencesOpen || isFullyPaid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullyPaid]);

  const totalExperiencesPrice =
    getTotalGrossIncludePackagedItem(experienceReservations) -
    getPackagesCommission(experienceReservations);

  if (onlyShowInfo) {
    return <Experiences onlyShowInfo />;
  }

  return (
    <>
      <Card>
        <Card.Header onClick={() => setExperiencesOpen(!experiencesOpen)}>
          <div>Experiences</div>
          <div>
            {totalExperiencesPrice !== 0 && (
              <span>{price(totalExperiencesPrice)}</span>
            )}
            <i
              className={`fas ms-3 ${
                experiencesOpen ? 'fa-chevron-up' : 'fa-chevron-down'
              }`}
            />
          </div>
        </Card.Header>
        <Collapse in={experiencesOpen}>
          <div>
            <Experiences />
            {totalExperiencesPrice !== 0 && (
              <Card.Footer>
                <div className="d-flex justify-content-between w-100">
                  <div className="left">
                    <div className="fw-bold">Subtotal</div>
                  </div>
                  <div className="right">
                    <div className="fw-bold">
                      {price(totalExperiencesPrice)}
                    </div>
                  </div>
                </div>
              </Card.Footer>
            )}
          </div>
        </Collapse>
      </Card>
    </>
  );
};

export default ExperiencesCard;

ExperiencesCard.propTypes = {
  onlyShowInfo: PropTypes.bool,
};
